import React from 'react';
import { FetchBaseQueryError,  }from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";
import { LoadingPlaceholder } from "case-web-ui"
import { ErrorComponent } from './ErrorComponent';

interface LoaderComponentProps {
    isLoading: boolean;
    error?: FetchBaseQueryError | SerializedError;
};
 
export const LoaderComponent: React.FC<LoaderComponentProps> = (props) => {

   if(props.isLoading) {
    return <LoadingPlaceholder minHeight={20} color="white"/>;
   } 

   if(props.error) {
      return <ErrorComponent error={props.error}/>
   }
   return <span/>;
 }
 